import { render, staticRenderFns } from "./EditOuter.vue?vue&type=template&id=0d36cb8c&scoped=true&"
import script from "./EditOuter.vue?vue&type=script&lang=js&"
export * from "./EditOuter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d36cb8c",
  null
  
)

export default component.exports